// useFetch rejects with heterogeneous shapes depending on the failure: an Error
// (has .message), the raw parsed JSON body (e.g. { message } or { error }), or a
// nested error payload ({ error: { message } }, { body: { message } }) - see
// helpers/useFetch.jsx. Normalise them into a user-facing string with a safe
// fallback so the UI never renders an empty/undefined error (which would leave
// the user with a stopped spinner and no feedback) or an [object Object].
const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later or contact support.';

const getErrorMessage = (error, fallback = DEFAULT_ERROR_MESSAGE) => {
  if (typeof error === 'string' && error.length > 0) {
    return error;
  }
  const candidates = [error?.message, error?.error?.message, error?.error, error?.body?.message, error?.body];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.length > 0) {
      return candidate;
    }
  }
  return fallback;
};

export default getErrorMessage;
